"use strict";

export default function () {
    const cards = document.querySelectorAll(
        ".termos .button-container .button"
    );
    const popups = document.querySelectorAll(".o-acesso-rapido");

    cards.forEach((item, index) => {
        item.addEventListener("click", () => {
            popups.forEach((popup) => popup.classList.remove("active"));
            popups[index].classList.add("active");
        });
    });

    const closePopup = document.querySelectorAll(".close-acess");
    closePopup.forEach((item, index) => {
        item.addEventListener("click", () => {
            popups.forEach((popup) => popup.classList.remove("active"));
        });
    });

    const listItens = document.querySelectorAll(".o-acesso-rapido a");

    listItens.forEach((item) => {
        item.addEventListener("click", (event) => {
            event.preventDefault();
            console.log(item);
            const targetId = item.getAttribute("href").substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                const offset = window.innerWidth > 768 ? 80 : 65;
                const targetPosition =
                    targetElement.getBoundingClientRect().top +
                    window.pageYOffset -
                    offset;

                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth",
                });

                popups.forEach((popup) => popup.classList.remove("active"));
            }
        });
    });
}
